import React, { useState } from 'react';
import { TabsDisplayNames, TabsNames } from 'enums/TabsNames';
import { ITab } from 'interfaces/ITab';
import { StyledTab, StyledTabs } from './StyledTabs';
import TabLabel from './components/TabLabel';

interface IProps {
  activeTab: number;
  setActiveTab: React.Dispatch<React.SetStateAction<number>>;
}

const Tabs: React.FC<IProps> = (props) => {
  const { activeTab, setActiveTab } = props;

  const tabs: ITab[] = [
    {
      id: '/',
      label: 'Teams and settings',
      // onClick: (): void => uiStore.setActiveTab(TabsNames.BallTracking),
    },
    {
      id: 'accepted',
      label: 'Features',
      // onClick: (): void => uiStore.setActiveTab(TabsNames.PlayerTracking),
    },
  ];

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number): void => {
    setActiveTab(newValue);
  };

  return (
    <StyledTabs value={activeTab} onChange={handleChange} indicatorColor='secondary'>
      {tabs.map((tab: ITab) => {
        return <StyledTab key={tab.id} label={<TabLabel label={tab.label} />} onClick={tab.onClick} />;
      })}
    </StyledTabs>
  );
};

export default Tabs;
